import { render } from "./WorkerProfile.vue?vue&type=template&id=640fe4a0&scoped=true"
import script from "./WorkerProfile.vue?vue&type=script&lang=js"
export * from "./WorkerProfile.vue?vue&type=script&lang=js"

import "./WorkerProfile.vue?vue&type=style&index=0&id=640fe4a0&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640fe4a0"]])

export default __exports__